import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { capacitorService } from '../../../../application/CapacitorService';
import { storageService } from '../../../../application/StorageService';
import { Modal } from '../../../../components/Modal';
import { Text } from '../../../../react-components/Text';

interface VersionComponentProps {
  open: boolean;
  onClose: () => void;
}
const APP_UPDATE_DISMISSED = `APP_UPDATE_DISMISSED`;

function compareAppleVersions(version1: string, version2: string) {
  try {
    const v1 = version1.split(`.`).map(Number);
    const v2 = version2.split(`.`).map(Number);

    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const part1 = v1[i] || 0; // default to 0 if undefined
      const part2 = v2[i] || 0; // default to 0 if undefined

      if (part1 > part2) {
        return 1; // version1 is greater
      } else if (part1 < part2) {
        return -1; // version2 is greater
      }
    }
    return 0; // versions are equal
  } catch (error) {
    console.error(`Error comparing versions:`, error);
    return -99; // Default to equal if there's an error
  }
}

export const VersionComponent = ({ open, onClose }: VersionComponentProps) => {
  const [localVersion, setLocalVersion] = useState<string | null>(null);

  useEffect(() => {
    const fetchLocalVersion = async () => {
      try {
        const res = await storageService.getItem({ key: APP_UPDATE_DISMISSED });
        setLocalVersion(res);
      } catch (error) {
        console.error(`Error fetching local version:`, error);
      }
    };

    fetchLocalVersion();
  }, []);

  let hasUpdate;
  let storeVersion = `0.0.0`;
  try {
    hasUpdate = capacitorService.hasDifferentVersion();
    storeVersion = capacitorService.getStoreVersion() ?? `0.0.0`;
  } catch (error) {
    console.error(`Error fetching local version:`, error);
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Grid display={`flex`} flexDirection={`column`} alignItems={`center`}>
        <Text variant="h4">App Version:</Text>
        {capacitorService.getAppVersionV2() ?? `0.0.0`}
        <Text variant="h4">Store Version:</Text>
        {storeVersion}
        <Text variant="h4">Dismissed Version:</Text>
        {localVersion ?? `0.0.0`}
        <Text variant="h4">Has Update:</Text>
        {hasUpdate ? `Yes` : `No`}
        <Text variant="h4">Should appear confirmation Modal:</Text>
        {compareAppleVersions(storeVersion, localVersion ?? `0.0.0`) > 0 ? `Yes` : `No`}
        {compareAppleVersions(storeVersion, localVersion ?? `0.0.0`)}
      </Grid>
    </Modal>
  );
};
